function cleanupDisposables(disposables) {
  return () => {
    for (const disposable of disposables) {
      disposable.dispose();
    }
  };
}
export {
  cleanupDisposables
};
//# sourceMappingURL=cleanup-disposables.js.map
